/**
 * A control-plane HTTP error that preserves the response **status code**, so the join
 * chain can tell a transient cross-task convergence blip (`404`/`409`/`503`, #67) from
 * a definitive failure. The dev client throws plain `Error`s (no cross-task routing in
 * dev), so `status` is simply absent there and nothing retries — same behavior as before.
 */
export class ApiError extends Error {
  readonly status: number | undefined;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}
